<template>
    <div class="ceshi-body">
        <el-upload action="cdn.bosscaigou.com" accept=".xlsx,.xls" :http-request="uploadFile" :limit="1"
            :show-file-list="false">
            <el-button type="warning">点击上传</el-button>
        </el-upload>
    </div>
</template>

<script>
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
export default {
    methods: {
        uploadFile(uploadInfo) {
            const _that = this;
            const reader = new FileReader()
            reader.onload = async (e) => {
                let templateBuffer = e.target.result
                let workbook = new ExcelJS.Workbook()
                await workbook.xlsx.load(templateBuffer);
                const worksheet = workbook.getWorksheet('Sheet1');
                const insertRowIndex = 17;
                // 插入新行数据
                const newData = [
                    ['', '1', '1', '1', '1', '1', '1', '1', 'https://cdn.bosscaigou.com/huayuan/img/cNNH4DyY7P_1740820487969_47.png'],
                    ['', '2', '2', '2', '2', '2', '2', '2', 'https://cdn.bosscaigou.com/huayuan/img/cNNH4DyY7P_1740820487969_47.png']
                ];

                let cellData = [];

                for (let i = 0; i < newData.length; i++) {

                    cellData.push(insertRowIndex + i);

                    worksheet.insertRow(insertRowIndex + i, newData[i]);

                    let imageBase64 = await _that.urlToBase64(newData[i][newData[i].length - 1]);
                    let imageId = workbook.addImage({
                        base64: imageBase64,
                        extension: 'png',
                    });
                    worksheet.addImage(imageId, {
                        tl: { col: 8, row: insertRowIndex + i - 1 }, // 对应B2
                        br: { col: 9, row: insertRowIndex + i },  // 占1列1行
                        editAs: 'oneCell'        // 图片嵌入单元格
                    });

                }

                newData.forEach((rowData, index) => {



                });

                worksheet.eachRow((row, rowNumber) => {
                    row.eachCell((cell) => {
                        if (cell.value && cell.value.toString().includes('#ceshi#')) {
                            cell.value = cell.value.toString().replace('#ceshi#', '新内容');
                        }
                    });
                });



                // worksheet.insertRow(insertRowIndex, newData);

                // 复制前一行样式
                const referenceRow = worksheet.getRow(insertRowIndex + newData.length);

                cellData.forEach((cell, index) => {
                    worksheet.getRow(cell).eachCell((cell, colNumber) => {
                        const refCell = referenceRow.getCell(colNumber);
                        cell.style = JSON.parse(JSON.stringify(refCell.style));//refCell.style;//
                        cell.alignment = { ...refCell.alignment };
                        cell.fill = refCell.fill;
                    });
                });

                // worksheet.getRow(insertRowIndex).eachCell((cell, colNumber) => {
                //     const refCell = referenceRow.getCell(colNumber);
                //     cell.style = refCell.style;//JSON.parse(JSON.stringify(refCell.style));//
                //     cell.alignment = { ...refCell.alignment };
                //     cell.fill = refCell.fill;
                //     // cell.value = refCell.value; // 包括公式
                // });
                // 调整合并区域
                Object.entries(worksheet._merges).forEach(([key, value]) => {
                    let merge = worksheet._merges[key];
                    if (merge.bottom >= insertRowIndex) {
                        merge.bottom += newData.length; // 调整底部
                        merge.top += newData.length; // 调整顶部
                    }
                });

                // 解除B5:D7合并
                // worksheet.unMergeCells('B5:D7');

                // 插入图片后重新合并
                // worksheet.mergeCells('B5:D7');

                const buffer = await workbook.xlsx.writeBuffer(); // ✅ 浏览器端专用 API
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                saveAs(blob, 'report.xlsx');

            }
            reader.readAsArrayBuffer(uploadInfo.file)
        },
        // 图片转Base64工具函数
        async urlToBase64(url) {
            const response = await fetch(url);
            const blob = await response.blob();
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result.split(',')[1]);
                reader.readAsDataURL(blob);
            });
        },
        uploadFile2(uploadInfo) {
            const reader = new FileReader()
            reader.onload = async (e) => {
                let templateBuffer = e.target.result
                const workbook = new ExcelJS.Workbook();
                await workbook.xlsx.load(templateBuffer);
                const worksheet = workbook.getWorksheet('Sheet1');

                // 插入新行
                const insertRowIndex = 17;
                const newData = ['', '1', '1', '1', '1', '1', '1', '1', '1'];
                worksheet.insertRow(insertRowIndex, newData);

                // 复制前一行的完整样式
                const refRow = worksheet.getRow(insertRowIndex + 1);
                const newRow = worksheet.getRow(insertRowIndex);
                refRow.eachCell({ includeEmpty: true }, (refCell, colNumber) => {
                    const newCell = newRow.getCell(colNumber);
                    newCell.style = JSON.parse(JSON.stringify(refCell.style));
                    newCell.alignment = { ...refCell.alignment };
                });

                // 调整合并区域
                // const originalMerges = worksheet._merges.splice(0);
                Object.entries(worksheet._merges).forEach(([key, value]) => {
                    let merge = worksheet._merges[key];
                    const { start, end } = ExcelJS.utils.decodeAddress(merge);
                    if (start.row >= insertRowIndex) {
                        start.row++;
                        end.row++;
                    } else if (end.row >= insertRowIndex) {
                        end.row++;
                    }
                    worksheet.mergeCells(
                        ExcelJS.utils.getCellAddress(start.row, start.column),
                        ExcelJS.utils.getCellAddress(end.row, end.column)
                    );
                });

                // 导出文件
                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                saveAs(blob, 'report.xlsx');
            }
            reader.readAsArrayBuffer(uploadInfo.file)
        },
        async insertRowWithStyle(uploadInfo) {

        }
    }
}
</script>

<style>
.ceshi-body {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
}
</style>